const locale = {
    placeholder: 'Velg tid',
};
export default locale;
